<div class="divider" translate>LEAD_GENERATION.IP_EXCLUSION</div>
<form [formGroup]="formGroup">
  <div class="lg-container border-top">
    <label class="w-45" translate>LEAD_GENERATION.IP_EXCLUSION_DESCRIPTION</label>
    <ui-switch formControlName="ipExclusionEnabled" class="pull-right custom"></ui-switch>
  </div>

  <div class="lg-container justify-content-end border-top" *ngIf="isIpExclusionEnabled" layout>
    <div formArrayName="blockedIps">
      <div class="input-wrapper"
           *ngFor="let ip of formGroup.controls.blockedIps.controls let i = index">
        <div class="input-error">
          <input
            type="text"
            class="light-grey-placeholder"
            [placeholder]="'LEAD_GENERATION.IP_EXCLUSION_PLACEHOLDER' | translate"
            [formControlName]="i"
            [value]="ip.value">
          <cc-input-errors
            [form]="formGroup"
            inputName="blockedIps"
            [inputIndex]="i"
            [errors]="[{'required': 'ERRORS.REQUIRED'  | translate  }, {'pattern': 'ERRORS.IP'  | translate }]">
          </cc-input-errors>
        </div>
        <div
          class="removalIcon align-item-center"
          *ngIf="formGroup.controls.blockedIps.length > 1"
          (click)="removeInputField(i)">
          <i
            class="material-icons pointer">delete</i>
        </div>
      </div>
        <a class="link pull-right" (click)="addNewInputField()" translate>LEAD_GENERATION.IP_EXCLUSION_INDEX_ANOTHER_IP</a>
    </div>
  </div>
</form>
